var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79893",
    "data-name": "Group 79893",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 365.42,
    height: 260.915,
    viewBox: "0 0 365.42 260.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19677",
    "data-name": "Rectangle 19677",
    width: 365.42,
    height: 260.915,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19659",
    "data-name": "Rectangle 19659",
    width: 348.237,
    height: 237.186,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19661",
    "data-name": "Rectangle 19661",
    width: 7.499,
    height: 3.415,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19663",
    "data-name": "Rectangle 19663",
    width: 156.867,
    height: 6.545,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19664",
    "data-name": "Rectangle 19664",
    width: 15.743,
    height: 17.653,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19667",
    "data-name": "Rectangle 19667",
    width: 95.439,
    height: 13.419,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19668",
    "data-name": "Rectangle 19668",
    width: 81.218,
    height: 21.271,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19669",
    "data-name": "Rectangle 19669",
    width: 81.218,
    height: 21.272,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79892",
    "data-name": "Group 79892",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79891",
    "data-name": "Group 79891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79890",
    "data-name": "Group 79890",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79865",
    "data-name": "Group 79865",
    transform: "translate(3.821)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79864",
    "data-name": "Group 79864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79863",
    "data-name": "Group 79863",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110262",
    "data-name": "Path 110262",
    d: "M339.565,183.877c-5.837-20.938,12.718-21.746,13.126-48.726.167-11.035-5.879-22.273-20.423-27.428-7.148-2.533-14.273-4.275-20.633-8.3-14.494-9.18-14.233-26.647-18.186-41.538C284.764,25.177,216.739-.825,182.911.02c-24.386.609-35.636,12.363-57.869,33.063C109.83,47.245,83.027,45.961,90.837,82.555c6.957,32.593-9.455,30.173-24.483,42.205-15,12.008-25.979,26.331-20.009,42.588,6.582,17.926-33.706,28.215-40.892,51.452C.579,234.561,26.179,235.893,43.6,235.893s166.483-1.34,229.531.525c16.969.5,71.111,5.124,78.769-16.03,5.213-14.4-8.26-21.888-12.337-36.51",
    transform: "translate(-4.847 0)",
    fill: "#c3ecfe"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_110263",
    "data-name": "Path 110263",
    d: "M436.226,224.949c-12.6,29.323-36.874,53.254-65.973,66.23",
    transform: "translate(-78.335 -47.593)",
    fill: "none",
    stroke: "#c3ecfe",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110264",
    "data-name": "Path 110264",
    d: "M449.239,229.693a24.143,24.143,0,0,0,8.312-14.607c.222-1.386.266-2.964-.665-4.014a1.574,1.574,0,0,0-.978-.566,2.016,2.016,0,0,0-1.575.857c-2.189,2.459-2.948,5.861-3.324,9.132s-1.091,5.671-1.77,9.2",
    transform: "translate(-95.047 -44.536)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110265",
    "data-name": "Path 110265",
    d: "M440.814,242.062a24.148,24.148,0,0,0,1.838-16.707c-.347-1.359-.931-2.826-2.2-3.42a1.577,1.577,0,0,0-1.123-.132,2.015,2.015,0,0,0-1.106,1.41c-1.034,3.126-.382,6.55.57,9.7s1.247,5.638,2.023,9.146",
    transform: "translate(-92.604 -46.916)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110266",
    "data-name": "Path 110266",
    d: "M430.128,257.65a24.145,24.145,0,0,0,3.866-16.357c-.177-1.392-.579-2.919-1.768-3.664a1.571,1.571,0,0,0-1.1-.267,2.012,2.012,0,0,0-1.27,1.265c-1.408,2.976-1.18,6.454-.62,9.7s.548,5.748.889,9.325",
    transform: "translate(-90.723 -50.215)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110267",
    "data-name": "Path 110267",
    d: "M417.3,271.307a24.145,24.145,0,0,0,3.867-16.357c-.177-1.392-.579-2.919-1.768-3.664a1.575,1.575,0,0,0-1.1-.267,2.014,2.014,0,0,0-1.27,1.265c-1.408,2.975-1.18,6.454-.62,9.7s.548,5.748.889,9.325",
    transform: "translate(-88.008 -53.105)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110268",
    "data-name": "Path 110268",
    d: "M398.429,287.128a24.148,24.148,0,0,0,5.54-15.868c-.033-1.4-.274-2.964-1.379-3.828a1.576,1.576,0,0,0-1.064-.38,2.015,2.015,0,0,0-1.395,1.127c-1.709,2.814-1.842,6.3-1.621,9.582s-.051,5.774-.081,9.367",
    transform: "translate(-84.297 -56.5)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110269",
    "data-name": "Path 110269",
    d: "M383.369,297.339a25.775,25.775,0,0,0,6.43-15.071c.121-1.4.08-2.974-.775-3.967a1.3,1.3,0,0,0-.871-.507c-.535-.026-.981.46-1.313.947-1.762,2.585-2.246,6.024-2.405,9.312s-.656,5.725-1.064,9.286",
    transform: "translate(-81.11 -58.773)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110270",
    "data-name": "Path 110270",
    d: "M437.849,250.868a26.16,26.16,0,0,0,17.292-3.318c1.28-.753,2.606-1.771,2.877-3.19a1.545,1.545,0,0,0-.157-1.133,2,2,0,0,0-1.7-.645c-3.412-.051-6.692,1.631-9.62,3.52s-5.356,2.938-8.688,4.765",
    transform: "translate(-92.637 -51.324)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110271",
    "data-name": "Path 110271",
    d: "M428.826,263.8a26.162,26.162,0,0,0,17.584.907c1.422-.427,2.953-1.1,3.555-2.411a1.544,1.544,0,0,0,.119-1.138,2,2,0,0,0-1.5-1.034c-3.3-.863-6.889-.013-10.183,1.123s-5.9,1.574-9.574,2.554",
    transform: "translate(-90.728 -54.961)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110272",
    "data-name": "Path 110272",
    d: "M415.347,278.4a26.159,26.159,0,0,0,17.047,4.406c1.479-.132,3.114-.485,3.966-1.651a1.544,1.544,0,0,0,.344-1.091c-.086-.615-.686-1.029-1.264-1.313-3.062-1.508-6.746-1.392-10.2-.937s-6.1.362-9.891.587",
    transform: "translate(-87.876 -58.714)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110273",
    "data-name": "Path 110273",
    d: "M396.492,293.339a26.162,26.162,0,0,0,17.6.515c1.413-.457,2.928-1.163,3.5-2.489a1.545,1.545,0,0,0,.094-1.14,2.007,2.007,0,0,0-1.524-1c-3.32-.79-6.886.14-10.155,1.349s-5.866,1.7-9.515,2.766",
    transform: "translate(-83.887 -61.13)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110274",
    "data-name": "Path 110274",
    d: "M381.246,303.625a26.159,26.159,0,0,0,15.483,8.382c1.467.228,3.138.28,4.247-.646a1.545,1.545,0,0,0,.6-.976,2,2,0,0,0-.911-1.579c-2.609-2.2-6.212-2.976-9.675-3.367s-6.005-1.118-9.741-1.813",
    transform: "translate(-80.661 -64.239)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110275",
    "data-name": "Path 110275",
    d: "M363.46,146.12a.31.31,0,0,1-.293-.289l-.11-1.568a.311.311,0,1,1,.62-.043l.11,1.567a.31.31,0,0,1-.288.332.211.211,0,0,1-.039,0",
    transform: "translate(-76.812 -30.452)",
    fill: "#599fd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110276",
    "data-name": "Path 110276",
    d: "M370.153,219.169l-4.145.291L361.4,152.634l2.072-.145,2.073-.146Z",
    transform: "translate(-76.462 -32.232)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110277",
    "data-name": "Path 110277",
    d: "M363.5,145.49l-.838.058-1.266,5.636,4.145-.29Z",
    transform: "translate(-76.462 -30.782)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110278",
    "data-name": "Path 110278",
    d: "M106.849,166.583c7.37,40.277,35.451,76.188,72.761,93.053",
    transform: "translate(-22.606 -35.244)",
    fill: "none",
    stroke: "#c3ecfe",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110279",
    "data-name": "Path 110279",
    d: "M107.9,171.854a24.142,24.142,0,0,1-4.846-16.093c.094-1.4.4-2.949,1.544-3.764a1.575,1.575,0,0,1,1.079-.334,2.014,2.014,0,0,1,1.344,1.186c1.586,2.886,1.567,6.371,1.2,9.643s-.2,5.771-.325,9.362",
    transform: "translate(-21.793 -32.086)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110280",
    "data-name": "Path 110280",
    d: "M113.6,186.062a24.146,24.146,0,0,1,1.933-16.7c.641-1.248,1.538-2.547,2.91-2.843a1.57,1.57,0,0,1,1.124.122,2.012,2.012,0,0,1,.763,1.622c.311,3.278-1.088,6.47-2.719,9.329s-2.473,5.219-4.011,8.465",
    transform: "translate(-23.888 -35.221)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110281",
    "data-name": "Path 110281",
    d: "M120.776,203.608a24.149,24.149,0,0,1-.122-16.807c.484-1.317,1.215-2.716,2.54-3.177a1.574,1.574,0,0,1,1.13-.017,2.016,2.016,0,0,1,.956,1.516c.709,3.215-.289,6.555-1.558,9.593s-1.817,5.482-2.946,8.892",
    transform: "translate(-25.221 -38.825)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110282",
    "data-name": "Path 110282",
    d: "M130.241,219.782a24.145,24.145,0,0,1-.122-16.807c.483-1.317,1.215-2.716,2.54-3.177a1.574,1.574,0,0,1,1.13-.017,2.016,2.016,0,0,1,.956,1.516c.709,3.215-.289,6.555-1.558,9.593s-1.817,5.482-2.946,8.892",
    transform: "translate(-27.223 -42.247)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110283",
    "data-name": "Path 110283",
    d: "M145.194,239.374a24.147,24.147,0,0,1-1.862-16.7c.345-1.36.927-2.828,2.2-3.424a1.571,1.571,0,0,1,1.122-.132,2.014,2.014,0,0,1,1.109,1.408c1.038,3.125.391,6.55-.557,9.7s-1.238,5.64-2.009,9.149",
    transform: "translate(-30.173 -46.347)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110284",
    "data-name": "Path 110284",
    d: "M157.474,252.594a25.773,25.773,0,0,1-2.907-16.125c.193-1.388.584-2.917,1.639-3.695a1.3,1.3,0,0,1,.963-.3c.528.094.854.667,1.069,1.217,1.142,2.912.846,6.374.27,9.613s-.637,5.727-1.034,9.29",
    transform: "translate(-32.648 -49.182)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110285",
    "data-name": "Path 110285",
    d: "M111.363,194.316a26.162,26.162,0,0,1-16.116-7.09c-1.079-1.019-2.146-2.307-2.093-3.751a1.541,1.541,0,0,1,.4-1.07,2,2,0,0,1,1.806-.249c3.337.711,6.16,3.081,8.592,5.577s4.566,4.057,7.406,6.582",
    transform: "translate(-19.708 -38.519)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110286",
    "data-name": "Path 110286",
    d: "M116.964,208.967a26.161,26.161,0,0,1-17.343-3.037c-1.291-.732-2.634-1.728-2.928-3.143a1.544,1.544,0,0,1,.138-1.135,2,2,0,0,1,1.694-.673c3.411-.106,6.717,1.522,9.676,3.364s5.4,2.851,8.763,4.624",
    transform: "translate(-20.448 -42.521)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110287",
    "data-name": "Path 110287",
    d: "M126.783,226.337a26.159,26.159,0,0,1-17.6.494c-1.412-.46-2.927-1.167-3.5-2.494a1.544,1.544,0,0,1-.092-1.14,2,2,0,0,1,1.525-1c3.322-.787,6.887.147,10.153,1.361s5.864,1.712,9.512,2.777",
    transform: "translate(-22.325 -46.95)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110288",
    "data-name": "Path 110288",
    d: "M141.917,244.959a26.161,26.161,0,0,1-17.271-3.422c-1.275-.761-2.595-1.787-2.857-3.207a1.546,1.546,0,0,1,.163-1.132,2.005,2.005,0,0,1,1.709-.635c3.413-.03,6.682,1.671,9.6,3.579s5.338,2.97,8.659,4.817",
    transform: "translate(-25.759 -50.05)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110289",
    "data-name": "Path 110289",
    d: "M154.437,259.315a26.159,26.159,0,0,1-16.962,4.72c-1.481-.106-3.121-.427-4-1.578a1.545,1.545,0,0,1-.364-1.084c.075-.617.667-1.042,1.24-1.336,3.034-1.563,6.719-1.516,10.182-1.125s6.1.248,9.9.4",
    transform: "translate(-28.162 -54.73)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110290",
    "data-name": "Path 110290",
    d: "M14.728,237.883c40.9-1.866,82.2,17.43,107.02,50",
    transform: "translate(-3.116 -50.303)",
    fill: "none",
    stroke: "#c3ecfe",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110291",
    "data-name": "Path 110291",
    d: "M20.245,237.254a24.149,24.149,0,0,0-16.771-1.108C2.131,236.552.691,237.2.154,238.5a1.572,1.572,0,0,0-.083,1.128,2.014,2.014,0,0,0,1.458,1.043c3.168.9,6.56.1,9.667-.993s5.579-1.492,9.05-2.42",
    transform: "translate(0 -49.749)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110292",
    "data-name": "Path 110292",
    d: "M35.573,239.12a24.146,24.146,0,0,0-15.835,5.634c-1.072.905-2.137,2.071-2.117,3.475a1.573,1.573,0,0,0,.371,1.067,2.014,2.014,0,0,0,1.752.38c3.263-.434,6.061-2.514,8.481-4.746s4.53-3.582,7.347-5.81",
    transform: "translate(-3.728 -50.591)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110293",
    "data-name": "Path 110293",
    d: "M54.2,242.309a24.148,24.148,0,0,0-16.4,3.656c-1.175.767-2.374,1.794-2.525,3.189a1.575,1.575,0,0,0,.237,1.105,2.016,2.016,0,0,0,1.693.591c3.292-.031,6.322-1.753,9-3.672s4.933-3,8-4.869",
    transform: "translate(-7.46 -51.218)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110294",
    "data-name": "Path 110294",
    d: "M72.089,247.9a24.148,24.148,0,0,0-16.4,3.656c-1.175.768-2.374,1.794-2.525,3.19a1.57,1.57,0,0,0,.238,1.1,2.014,2.014,0,0,0,1.692.591c3.292-.032,6.322-1.754,9-3.673s4.933-3,8-4.869",
    transform: "translate(-11.244 -52.401)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110295",
    "data-name": "Path 110295",
    d: "M94.484,258.2a24.145,24.145,0,0,0-16.695,1.937c-1.248.642-2.547,1.539-2.843,2.91a1.573,1.573,0,0,0,.123,1.124,2.012,2.012,0,0,0,1.622.763c3.277.31,6.47-1.09,9.329-2.721s5.218-2.474,8.464-4.013",
    transform: "translate(-15.846 -54.48)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110296",
    "data-name": "Path 110296",
    d: "M110.07,267.278a25.77,25.77,0,0,0-16.365.789c-1.31.5-2.712,1.225-3.233,2.428A1.3,1.3,0,0,0,90.4,271.5c.211.494.842.683,1.425.769,3.094.459,6.4-.606,9.429-1.9s5.437-1.907,8.82-3.094",
    transform: "translate(-19.11 -56.342)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110297",
    "data-name": "Path 110297",
    d: "M42.837,235.973a26.157,26.157,0,0,0-10.529-14.112c-1.235-.823-2.73-1.573-4.125-1.2a1.543,1.543,0,0,0-.952.635,2,2,0,0,0,.163,1.815c1.443,3.093,4.386,5.311,7.365,7.121s4.98,3.537,8.077,5.738",
    transform: "translate(-5.728 -46.665)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110298",
    "data-name": "Path 110298",
    d: "M58.394,238.155a26.162,26.162,0,0,0-6.855-16.217c-1-1.094-2.276-2.179-3.721-2.148a1.546,1.546,0,0,0-1.075.389,2,2,0,0,0-.275,1.8c.663,3.348,2.992,6.2,5.452,8.673s3.991,4.624,6.475,7.5",
    transform: "translate(-9.814 -46.501)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110299",
    "data-name": "Path 110299",
    d: "M77.606,243.8a26.159,26.159,0,0,0-3.472-17.261c-.765-1.273-1.794-2.59-3.215-2.849a1.543,1.543,0,0,0-1.132.167,2,2,0,0,0-.63,1.71c-.021,3.413,1.69,6.677,3.607,9.588s2.985,5.329,4.843,8.644",
    transform: "translate(-14.631 -47.32)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110300",
    "data-name": "Path 110300",
    d: "M99.067,254.384a26.16,26.16,0,0,0-7.214-16.061c-1.028-1.072-2.323-2.127-3.767-2.064a1.546,1.546,0,0,0-1.067.413,2,2,0,0,0-.235,1.808c.737,3.333,3.129,6.136,5.644,8.549s4.093,4.534,6.639,7.355",
    transform: "translate(-18.34 -49.985)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110301",
    "data-name": "Path 110301",
    d: "M116.12,263.28a26.163,26.163,0,0,0,.788-17.589c-.435-1.42-1.117-2.946-2.435-3.539a1.544,1.544,0,0,0-1.138-.111,2,2,0,0,0-1.023,1.508c-.842,3.307.032,6.888,1.191,10.175s1.614,5.891,2.618,9.557",
    transform: "translate(-23.691 -51.195)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110302",
    "data-name": "Path 110302",
    d: "M146.852,257.8a28.942,28.942,0,0,0-22.365-7.552c-5.466.553-11.427,3.473-12.63,8.834-.572,2.553-.372,5.94-2.789,6.943-2.364.982-4.649-1.455-7.077-2.269-4.041-1.355-8.654,3.266-7.291,7.3.62,1.837,2.174,3.437,2.045,5.371-.176,2.634-3.431,4.008-6.039,3.6s-4.91-1.932-7.468-2.583-5.871,0-6.77,2.483c-.805,2.225.584,5.215-1.163,6.81a4.763,4.763,0,0,1-2.841.92c-22.15,2.1-46.545,6.076-44.066,10.011.677,1.076,2.409.733,3.68.714,47.146-.738,89.971-1.441,137.1,0",
    transform: "translate(-5.972 -52.917)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110303",
    "data-name": "Path 110303",
    d: "M345.223,165.939,359.2,220.744l-2.659.678-17.293-53.96",
    transform: "translate(-71.776 -35.108)",
    fill: "#88d2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110304",
    "data-name": "Path 110304",
    d: "M325.717,159.038c-7.137,1.82-14.733-3.715-16.932-12.338s1.819-17.121,8.956-18.94,14.733,3.715,16.931,12.339-1.818,17.12-8.955,18.94m-6.754-26.483c-4.492,1.146-6.908,6.943-5.383,12.922s6.422,9.911,10.914,8.766,6.907-6.943,5.383-12.922-6.421-9.911-10.913-8.766",
    transform: "translate(-65.203 -26.957)",
    fill: "#9bdfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110305",
    "data-name": "Path 110305",
    d: "M337.685,148.195l4.25,16.664a1.566,1.566,0,1,1-3.035.774l-.479-1.883s-2.232-4.76-8.4-2.8c0,0,7.358-.919,7.608-.9s-.173-12.766.058-11.857",
    transform: "translate(-69.823 -31.344)",
    fill: "#c0edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110306",
    "data-name": "Path 110306",
    d: "M341.294,168.425a4.045,4.045,0,0,1-4.913-2.916,6.491,6.491,0,0,0-.764-2.036c-.8-1.135-2.43-1.561-5.412-.8l-.755-4.213c1.567-.5,2.695-1.257,3.956-1.169.675-.083,1.236-.151,1.706-.205,0-1.291-.03-2.993-.05-4.3-.02-1.386,1.78-2.945,1.775-3.941-.006-1.786-1.839-3.59.378-3.888l2.18-.29,4.815,18.842a4.044,4.044,0,0,1-2.916,4.913",
    transform: "translate(-69.703 -30.608)",
    fill: "#9bdfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110307",
    "data-name": "Path 110307",
    d: "M349.436,165.308l.041,56.559,2.744,0L355.6,165.3",
    transform: "translate(-73.931 -34.974)",
    fill: "#88d2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110308",
    "data-name": "Path 110308",
    d: "M348.764,137.988c-.006-8.9,5.981-16.145,13.346-16.15s13.363,7.231,13.369,16.13-5.981,16.145-13.346,16.149-13.364-7.231-13.37-16.13m4.949,0c0,6.171,3.781,11.189,8.417,11.185s8.405-5.027,8.4-11.2-3.781-11.188-8.417-11.185-8.405,5.026-8.4,11.2",
    transform: "translate(-73.789 -25.778)",
    fill: "#9bdfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110309",
    "data-name": "Path 110309",
    d: "M351.905,146.361c0,.938.013,17.2.013,17.2a1.566,1.566,0,1,0,3.132,0l0-1.942s.982-5.164,7.446-4.792c0,0-7.357.933-7.595,1.012s-3-12.411-2.994-11.473",
    transform: "translate(-74.454 -30.955)",
    fill: "#c0edff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110310",
    "data-name": "Path 110310",
    d: "M352.825,166.933a4.045,4.045,0,0,0,4.038-4.043,6.5,6.5,0,0,1,.236-2.162c.493-1.3,1.967-2.115,5.045-2.117l-.313-4.268c-1.643-.1-2.923-.551-4.122-.153-.676.088-1.236.161-1.7.224-.315-1.251-.713-2.906-1.016-4.175-.325-1.348-2.454-2.412-2.7-3.378-.437-1.732.891-3.934-1.33-3.673l-2.185.259,0,19.447a4.045,4.045,0,0,0,4.043,4.038",
    transform: "translate(-73.792 -30.29)",
    fill: "#9bdfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110311",
    "data-name": "Path 110311",
    d: "M377.727,207.389l-7.113-1.284,11.049-61.179a.921.921,0,0,1,1.071-.743l5.3.956a.924.924,0,0,1,.744,1.071Z",
    transform: "translate(-78.412 -30.502)",
    fill: "#88d2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110312",
    "data-name": "Path 110312",
    d: "M390.394,152.09l-7.113-1.284,1.062-5.88a.922.922,0,0,1,1.071-.743l5.3.957a.923.923,0,0,1,.743,1.071Z",
    transform: "translate(-81.092 -30.502)",
    fill: "#fe7d90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79868",
    "data-name": "Group 79868",
    transform: "translate(301.807 120.309)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79867",
    "data-name": "Group 79867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79866",
    "data-name": "Group 79866",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19660",
    "data-name": "Rectangle 19660",
    width: 2.164,
    height: 7.229,
    transform: "translate(0 2.13) rotate(-79.76)",
    fill: "#599fd2"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19662",
    "data-name": "Rectangle 19662",
    width: 67.507,
    height: 12.477,
    transform: "matrix(0.367, -0.93, 0.93, 0.367, 293.279, 186.341)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(325.01 128.646)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(323.724 131.908)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    x2: 3.825,
    y2: 1.508,
    transform: "translate(322.438 135.17)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x2: 5.697,
    y2: 2.245,
    transform: "translate(319.281 137.695)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(319.867 141.695)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(318.581 144.957)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(317.295 148.219)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x2: 5.698,
    y2: 2.245,
    transform: "translate(314.138 150.744)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(314.724 154.743)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(313.438 158.006)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    x2: 3.825,
    y2: 1.508,
    transform: "translate(312.152 161.268)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    x2: 5.698,
    y2: 2.245,
    transform: "translate(308.994 163.792)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(309.58 167.792)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(308.294 171.055)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(307.009 174.317)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_186",
    "data-name": "Line 186",
    x2: 5.697,
    y2: 2.245,
    transform: "translate(303.851 176.841)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    x2: 3.826,
    y2: 1.507,
    transform: "translate(304.437 180.841)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(303.151 184.103)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_189",
    "data-name": "Line 189",
    x2: 3.826,
    y2: 1.508,
    transform: "translate(301.866 187.366)",
    fill: "none",
    stroke: "#ccf3ff",
    strokeWidth: 1.393
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110313",
    "data-name": "Path 110313",
    d: "M379.318,290.813H321.433l-9.722-87.566a1.88,1.88,0,0,1,1.868-2.087h73.593a1.879,1.879,0,0,1,1.868,2.087Z",
    transform: "translate(-65.947 -42.56)",
    fill: "#9bdfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110314",
    "data-name": "Path 110314",
    d: "M299.206,306.311l104.6,1.425c1.17.016,4.858-1.125-1.5-5.223-5.382-3.471-22.395-.348-22.395-.348s3.96-1.587,3.942-3.636a5.553,5.553,0,0,0-3.436-4.7,12.746,12.746,0,0,0-6.034-.794,38.455,38.455,0,0,0-12.153,2.719,3.524,3.524,0,1,0-4.087-5.722c2.613-3.538,6.653-19.221-5.763-26.133-15.562-8.662-27.381-1.533-29.9,3.68-1.28-5.118-7.151-8.993-11.019-9.953-8.82-2.19-14.565-1.541-22.8,2.3-2.913,1.361-6.814,6.007-8.75,8.573-3.033,4.02-3.506,9.364-3.672,14.4q-.189,5.666-.051,11.337",
    transform: "translate(-58.421 -54.243)",
    fill: "#ccf3ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79871",
    "data-name": "Group 79871",
    transform: "translate(104.292 254.37)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79870",
    "data-name": "Group 79870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79869",
    "data-name": "Group 79869",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110315",
    "data-name": "Path 110315",
    d: "M289.145,325.9c0,1.807-35.116,3.273-78.434,3.273s-78.433-1.466-78.433-3.273,35.116-3.273,78.433-3.273,78.434,1.466,78.434,3.273",
    transform: "translate(-132.278 -322.629)",
    fill: "#a1d7e5"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_110316",
    "data-name": "Path 110316",
    d: "M231.542,37.224a7.872,7.872,0,0,0-7.873,7.872V55.184h15.743V45.1a7.872,7.872,0,0,0-7.871-7.872m0,12.389a4.416,4.416,0,1,1,4.416-4.416,4.417,4.417,0,0,1-4.416,4.416",
    transform: "translate(-47.322 -7.876)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79874",
    "data-name": "Group 79874",
    transform: "translate(176.348 29.655)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79873",
    "data-name": "Group 79873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79872",
    "data-name": "Group 79872",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110317",
    "data-name": "Path 110317",
    d: "M235.958,45.279a4.317,4.317,0,0,0-5.08-4.35,3.243,3.243,0,0,1,1.792-.429,4.416,4.416,0,0,1,4.416,4.416,3.583,3.583,0,0,1-2.833,3.848,4.827,4.827,0,0,0,1.7-3.485m-9.883,8.979V44.17a7.681,7.681,0,0,1,3.309-6.557,7.87,7.87,0,0,0-5.714,7.564V55.265h15.743V54.258Z",
    transform: "translate(-223.67 -37.613)",
    fill: "#b03d44"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_110318",
    "data-name": "Path 110318",
    d: "M278.353,270.443h-133a7.681,7.681,0,0,1-7.681-7.681V68.355a7.68,7.68,0,0,1,7.681-7.68h133a7.681,7.681,0,0,1,7.681,7.68V262.762a7.681,7.681,0,0,1-7.681,7.681",
    transform: "translate(-29.128 -12.837)",
    fill: "#3e89cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19665",
    "data-name": "Rectangle 19665",
    width: 131.164,
    height: 193.315,
    transform: "translate(117.144 56.064)",
    fill: "#c3ecfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19666",
    "data-name": "Rectangle 19666",
    width: 121.077,
    height: 181.502,
    transform: "translate(122.187 61.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110319",
    "data-name": "Path 110319",
    d: "M266.671,63.594v7.884H171.232V63.594a5.415,5.415,0,0,1,.252-1.648,5.537,5.537,0,0,1,5.282-3.887h84.37a5.532,5.532,0,0,1,5.535,5.535",
    transform: "translate(-36.228 -12.284)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79877",
    "data-name": "Group 79877",
    transform: "translate(135.004 45.775)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79876",
    "data-name": "Group 79876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79875",
    "data-name": "Group 79875",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110320",
    "data-name": "Path 110320",
    d: "M266.671,69.507v1.971H171.232V65.77a24.543,24.543,0,0,1,.252-3.824,5.537,5.537,0,0,1,5.282-3.887h.678a8.237,8.237,0,0,0-2.523,5.74v5.708Z",
    transform: "translate(-171.232 -58.059)",
    fill: "#b03d44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79880",
    "data-name": "Group 79880",
    transform: "translate(154.533 80.036)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79879",
    "data-name": "Group 79879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79878",
    "data-name": "Group 79878",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_190",
    "data-name": "Line 190",
    x2: 19.667,
    transform: "translate(1.231 1.23)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    x2: 14.954,
    transform: "translate(65.034 7.5)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    x2: 57.323,
    transform: "translate(1.231 7.5)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_193",
    "data-name": "Line 193",
    x2: 78.758,
    transform: "translate(1.231 13.771)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_194",
    "data-name": "Line 194",
    x2: 25.033,
    transform: "translate(54.955 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_195",
    "data-name": "Line 195",
    x2: 47.493,
    transform: "translate(1.231 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_196",
    "data-name": "Line 196",
    x2: 52.636,
    transform: "translate(27.352 1.23)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79883",
    "data-name": "Group 79883",
    transform: "translate(154.533 125.109)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79882",
    "data-name": "Group 79882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79881",
    "data-name": "Group 79881",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_197",
    "data-name": "Line 197",
    x2: 19.667,
    transform: "translate(1.231 1.231)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    x2: 14.954,
    transform: "translate(65.034 7.501)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    x2: 57.323,
    transform: "translate(1.231 7.501)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    x2: 78.758,
    transform: "translate(1.231 13.771)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    x2: 25.033,
    transform: "translate(54.955 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    x2: 47.493,
    transform: "translate(1.231 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    x2: 52.636,
    transform: "translate(27.352 1.231)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79886",
    "data-name": "Group 79886",
    transform: "translate(154.533 168.607)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79885",
    "data-name": "Group 79885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79884",
    "data-name": "Group 79884",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    x2: 19.667,
    transform: "translate(1.231 1.23)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    x2: 14.954,
    transform: "translate(65.034 7.5)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    x2: 57.323,
    transform: "translate(1.231 7.5)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    x2: 78.758,
    transform: "translate(1.231 13.771)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    x2: 25.033,
    transform: "translate(54.955 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    x2: 47.493,
    transform: "translate(1.231 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    x2: 52.636,
    transform: "translate(27.352 1.23)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79889",
    "data-name": "Group 79889",
    transform: "translate(154.533 212.892)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79888",
    "data-name": "Group 79888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79887",
    "data-name": "Group 79887",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    x2: 19.667,
    transform: "translate(1.231 1.231)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    x2: 14.954,
    transform: "translate(65.034 7.501)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    x2: 57.323,
    transform: "translate(1.231 7.501)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    x2: 78.758,
    transform: "translate(1.231 13.771)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    x2: 25.033,
    transform: "translate(54.955 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    x2: 47.493,
    transform: "translate(1.231 20.041)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    x2: 52.636,
    transform: "translate(27.352 1.231)",
    fill: "none",
    stroke: "#0964af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.122
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19672",
    "data-name": "Rectangle 19672",
    d: "M2.1,0H15.929a2.1,2.1,0,0,1,2.1,2.1V15.928a2.1,2.1,0,0,1-2.1,2.1H2.1a2.1,2.1,0,0,1-2.1-2.1V2.1A2.1,2.1,0,0,1,2.1,0Z",
    transform: "translate(131.093 79.374)",
    fill: "none",
    stroke: "#2396b5",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19673",
    "data-name": "Rectangle 19673",
    d: "M2.1,0H15.929a2.1,2.1,0,0,1,2.1,2.1V15.929a2.1,2.1,0,0,1-2.1,2.1H2.1a2.1,2.1,0,0,1-2.1-2.1V2.1A2.1,2.1,0,0,1,2.1,0Z",
    transform: "translate(131.093 124.301)",
    fill: "none",
    stroke: "#2396b5",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19674",
    "data-name": "Rectangle 19674",
    width: 18.03,
    height: 18.03,
    rx: 2.102,
    transform: "translate(131.093 169.229)",
    fill: "none",
    stroke: "#2396b5",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19675",
    "data-name": "Rectangle 19675",
    width: 18.031,
    height: 18.03,
    rx: 2.102,
    transform: "translate(131.093 214.157)",
    fill: "none",
    stroke: "#2396b5",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110321",
    "data-name": "Path 110321",
    d: "M169.086,104.747l6.8,8.208,13.076-20.632",
    transform: "translate(-35.774 -19.533)",
    fill: "none",
    stroke: "#ffa829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110322",
    "data-name": "Path 110322",
    d: "M169.086,161.258l6.8,8.207,13.076-20.632",
    transform: "translate(-35.774 -31.489)",
    fill: "none",
    stroke: "#ffa829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.47
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.1321213999f4798a6c6f86dfe18c3aff.svg";
export { ForwardRef as ReactComponent };